import { ArrowCircleDownOutlined, Close } from "@mui/icons-material";
import {
  Box,
  Dialog,
  DialogActions,
  DialogContentText,
  DialogTitle,
  FormControl,
  FormControlLabel,
  FormLabel,
  IconButton,
  Radio,
  RadioGroup,
} from "@mui/material";
import FormActionButton from "../buttons/formActionButton.component";
import { useState } from "react";
import {
  downloadFile,
  generateGeoJSON,
  generateKML,
  generateSHP,
} from "../../utils/downloadDataUtils";

const formatOptions = [
  { value: "kml", label: "Kml" },
  { value: "geoJson", label: "GeoJson" },
  { value: "shp", label: "Shp" },
];

const GisFormatDialog = ({ onClose, open, field }) => {
  const [selectedFormat, setSelectedFormat] = useState("kml");

  const handleChange = (e) => {
    setSelectedFormat(e.target.value);
  };

  const handleDownload = async () => {
    try {
      switch (selectedFormat) {
        case "kml":
          const kmlContent = generateKML(field);
          await downloadFile(kmlContent, field.name || "campo", "kml");
          break;
        case "geoJson":
          const geoJsonContent = generateGeoJSON(field);
          await downloadFile(geoJsonContent, field.name || "campo", "geoJson");
          break;
        case "shp":
          const shpContent = generateSHP(field);
          await downloadFile(shpContent, field.name || "campo", "shp");
          break;
        default:
          console.error("Formato non supportato");
      }
      onClose();
    } catch (error) {
      console.error("Errore durante il download:", error);
    }
  };

  return (
    <Dialog
      onClose={onClose}
      open={open}
      sx={{
        "& .MuiDialog-paper": {
          padding: 1,
          width: "400px",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
        },
      }}
      aria-labelledby="gis-dialog-title"
      aria-describedby="gis-dialog-description"
    >
      <Box width="100%" height="100%" display="flex" justifyContent="end">
        <IconButton aria-label="close" onClick={onClose}>
          <Close
            sx={{ width: "20px", height: "20px", color: "text.primary" }}
          />
        </IconButton>
      </Box>
      <Box width="100%" height="100%" display="flex" justifyContent="center">
        <ArrowCircleDownOutlined sx={{ width: "40px", height: "40px" }} />
      </Box>
      <DialogTitle
        id="gis-dialog-title"
        sx={{ fontWeight: "bold", fontSize: "20px", textAlign: "center" }}
      >
        Scarica file
      </DialogTitle>
      <DialogContentText
        id="gis-dialog-description"
        sx={{ fontSize: "14px", textAlign: "center" }}
      >
        Seleziona il formato del file
      </DialogContentText>
      <Box width="100%" height="100%" p={1}>
        <FormControl>
          <FormLabel id="format-radio-buttons-label">Formato file</FormLabel>
          <RadioGroup
            aria-labelledby="format-radio-buttons-label"
            name="radio-buttons-group"
            value={selectedFormat}
            onChange={handleChange}
          >
            {formatOptions.map((option) => (
              <FormControlLabel
                key={option.value}
                value={option.value}
                control={<Radio />}
                label={option.label}
              />
            ))}
          </RadioGroup>
        </FormControl>
      </Box>
      <DialogActions sx={{ justifyContent: "center", mb: 4 }}>
        <FormActionButton label="Scarica" onClick={handleDownload} />
      </DialogActions>
    </Dialog>
  );
};

export default GisFormatDialog;
